import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnTimezones, ISnStream } from '@lib/api/entities';

@Injectable({
  providedIn: 'root',
})
export class SnConstantsAPI {
  private readonly _timezones$: Observable<ISnTimezones>;
  private readonly _stream$: Observable<ISnStream>;

  constructor(httpClient: HttpClient) {
    this._timezones$ = httpClient
      .get<ISnTimezones>('/api/service/constants/timezones/')
      .pipe(shareReplay());

    this._stream$ = httpClient
      .get<ISnStream>('/api/service/constants/streaming/')
      .pipe(shareReplay());
  }

  public getStream(): Observable<ISnStream> {
    return this._stream$;
  }

  public getTimezones(): Observable<ISnTimezones> {
    return this._timezones$;
  }
}
